import { JsonHalCollectionPageInfo } from '../api/jsonhal.model';

export interface ITablePageInfo {
  number: number;
  maxSize: number;
  currSize: number;
  totalItems: number;
  totalPages: number;
}

export function jsonHalPageInfoToTablePageInfo(
  pageInfo: JsonHalCollectionPageInfo,
  maxPageSize: number
): ITablePageInfo {
  return {
    number: pageInfo.number,
    currSize: pageInfo.size,
    maxSize: maxPageSize,
    totalItems: pageInfo.totalItems,
    totalPages: pageInfo.totalPages,
  };
}
